import React from 'react';
import PropTypes from 'prop-types';
import RichText from 'components/rich-text';

const RichTextBlock = ({ textHtml }) => {
  return (
    <div className="rich-text-block block">
      <RichText text={textHtml} className="rich-text-block__content" />
    </div>
  );
};

RichTextBlock.propTypes = {
  textHtml: PropTypes.string,
};

export default RichTextBlock;
